import { bareIzteachClient, bareQltClient, qltClient } from '../clients';
import { izteachSession } from '../session';
import type { IzteachSignInResult, QltSignInResult, QltUser } from '../types';

// Both handshakes run on bare clients: no token exists yet, and a 401 here must not
// trigger the recovery machinery.

export const AuthRepository = {
  // Strapi v3 custom route, not /auth/local. Returns { jwt, user, policies }.
  signIn: (identifier: string, password: string) =>
    bareQltClient
      .post('/auth/log-in', { identifier, password })
      .then((res) => res.data as QltSignInResult),

  // Returns the jwt as a bare string. Also invoked by the qlt client's 401 recovery.
  refreshToken: (id: string | number) =>
    bareQltClient.post('/refreshToken', { id }).then((res) => {
      const data = res.data as unknown;
      return typeof data === 'string' ? data : ((data as { jwt?: string }).jwt as string);
    }),

  me: () => qltClient.get('/users/me').then((res) => res.data as QltUser),

  forgotPassword: (email: string) => bareQltClient.post('/auth/forgot-password', { email }),

  // QLT -> IZTeach SSO. The QLT jwt is exchanged for IZTeach credentials.
  signInIzteachWithQlt: (token: string, vendorId?: string) =>
    bareIzteachClient('student')
      .post('/student/qlt-signin', { token, vendorId: vendorId || izteachSession.vendorId })
      .then((res) => res.data as IzteachSignInResult),
};

export default AuthRepository;
